import { IObservable, Subject } from '~/rage/utils';
import {
	Gender,
	IClientConfigs,
	IPedAppearanceValue,
	IPedFaceMorphValue,
	IPedOverlayValue,
	IPedParentsValue,
	PedHeadPosition,
} from '~/shared';

export abstract class AbstractCharacterCreationService {
	protected parents = new Subject<IClientConfigs['appearance']['parents']>([]);
	protected faceMorphs = new Subject<
		IClientConfigs['appearance']['faceMorphs']
	>([]);
	protected overlaySections = new Subject<
		IClientConfigs['appearance']['overlaySections']
	>([]);
	protected overlaysFemale = new Subject<
		IClientConfigs['appearance']['overlays']
	>([]);
	protected overlaysMale = new Subject<
		IClientConfigs['appearance']['overlays']
	>([]);
	protected hairColors = new Subject<
		IClientConfigs['appearance']['hairColors']
	>([]);
	protected makeupColors = new Subject<
		IClientConfigs['appearance']['makeupColors']
	>([]);

	public abstract setGenderValue(gender: Gender): Promise<void>;

	public getParentConfigs(): IObservable<
		IClientConfigs['appearance']['parents']
	> {
		return this.parents;
	}

	public abstract setParentsValue(parents: IPedParentsValue): Promise<void>;

	public getFaceMorphConfigs(): IObservable<
		IClientConfigs['appearance']['faceMorphs']
	> {
		return this.faceMorphs;
	}

	public abstract setFaceMorphValues(
		morphs: IPedFaceMorphValue[],
	): Promise<void>;

	public getOverlaySectionConfigs(): IObservable<
		IClientConfigs['appearance']['overlaySections']
	> {
		return this.overlaySections;
	}

	public getOverlayConfigsByGender(
		gender: Gender,
	): IObservable<IClientConfigs['appearance']['overlays']> {
		return gender === Gender.FEMALE ? this.overlaysFemale : this.overlaysMale;
	}

	public abstract setOverlayValues(overlays: IPedOverlayValue[]): Promise<void>;

	public abstract setAppearanceValue(
		appearance: IPedAppearanceValue,
	): Promise<void>;

	public abstract setHeadPosition(position: PedHeadPosition): Promise<void>;

	public getHairColors(): IObservable<
		IClientConfigs['appearance']['hairColors']
	> {
		return this.hairColors;
	}

	public getMakeupColors(): IObservable<
		IClientConfigs['appearance']['makeupColors']
	> {
		return this.makeupColors;
	}

	public abstract exit(): Promise<void>;
}
